import { ExercisesByUserAndDate, FlatPatientExercise } from '@/store/modules/exercise/getters'
import moment from 'moment-timezone'

export const convertToExercisesByUserAndDate = (exercises: FlatPatientExercise[]): ExercisesByUserAndDate => {
  const dataByUser: ExercisesByUserAndDate = {}
  exercises.forEach(exercise => {
    const patientId = exercise.patientId
    const date = moment(exercise.exerciseDate, 'YYYY-MM-DD')
    const dateKey = date.format('MMMM')

    if (!dataByUser[patientId]) {
      dataByUser[patientId] = {}
    }

    if (!dataByUser[patientId][dateKey]) {
      dataByUser[patientId][dateKey] = []
    }

    dataByUser[patientId][dateKey].push(exercise)
  })
  return dataByUser
}

export const sortExercisesByDate = (exercises: FlatPatientExercise[]): FlatPatientExercise[] => {
  return exercises
    .sort((a, b) => b.createdTimestamp - a.createdTimestamp)
    .sort((a, b) => new Date(b.exerciseDate).getTime() - new Date(a.exerciseDate).getTime())
}
